import React, { useCallback, useMemo, useState } from 'react'
import { useDetectionExplorerStore, useToggleSelectedDetection } from '../DetectionExplorerStore'
import { DetectionDetailModal } from '../Gallery'
import { DetectionResult } from '../get_detections'
import { TableUI } from './TableUI'

type Props = {
    items: DetectionResult[]
}

export const TableContainer: React.FC<Props> = ({ items }) => {
    const selectedById = useDetectionExplorerStore((s) => s.selectedById)
    const addDeviceToFilter = useDetectionExplorerStore((s) => s.addDeviceToFilter)
    const handleToggle = useToggleSelectedDetection(items)

    const [activeDetectionId, setActiveDetectionId] = useState<string | null>(null)
    const activeDetection = useMemo(
        () => items.find((d) => d.detection_uuid === activeDetectionId) ?? null,
        [items, activeDetectionId]
    )

    const handleOpenDetail = useCallback((id: string) => setActiveDetectionId(id), [])
    const handleCloseDetail = useCallback(() => setActiveDetectionId(null), [])

    return (
        <>
            <TableUI
                items={items}
                selectedIds={Object.keys(selectedById)}
                onToggleSelect={handleToggle}
                onOpenDetail={handleOpenDetail}
                onFilterDevice={addDeviceToFilter}
            />
            {activeDetection && <DetectionDetailModal detection={activeDetection} onClose={handleCloseDetail} />}
        </>
    )
}
